<script>
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";

export default {
  components: {
    Vue3ChartJs
  },
  name: "LeadSourceChart",
  props: {
    chartData: {
      type: Array,
      required: true,
      default: () => []
    },
    chartConfig: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: String,
      default: "Lead Source Distribution"
    },
    chartKey: {
      type: [String, Number],
      default: 0
    }
  },

  computed: {
   labels() {
    return this.chartData?.map(item => item.source) || [];
   },
   series() {
    return this.chartData?.map(item => Number(item.count) || 0) || [];
   },
   bgColors() {
    const randomColor = () => {
     return '#' + Math.floor(Math.random()*16777215).toString(16).padStart(6, '0');
    };

    return this.chartData?.map(() => randomColor()) || [];
   },
   chartOptions() {
   return {
    labels: this.labels,
    colors: this.bgColors,
    legend: {
      show: true,
      position: "right",
      fontSize: "14px",
      labels: {
        colors: "#000"
      },
      markers: {
        width: 12,
        height: 12,
        radius: 12
      },
      itemMargin: {
        horizontal: 5,
        vertical: 5
      }
    },
    cutout: "60%",
    responsive: [
     {
      breakpoint: 480,
      options: {
       chart: {
        width: 300
       },
       legend: {
        position: "bottom"
       }
      }
     }
    ]
   };
  }


  }
};
</script>

<template>
<div class="card" v-if="chartData">
  <div class="card-header"><h5 class="card-title">{{ title }}</h5></div>
   <div class="card-body">
    <apexchart :key="chartKey" v-if="series.length && chartOptions.labels.length" type="donut" height="300" :options="chartOptions" :series="series" />
   </div>
  </div>
</template>